import React, { useContext, useEffect, useState } from 'react';
import { IComment } from 'src/components/Comments/Comment';
import Comments from '../../../components/Comments';
import { useListCorrespondenceQuery } from 'src/state/slice/correspondenceApi';
import { KatAlert, KatDivider, KatSpinner } from '@amzn/katal-react';
import CorrespondenceDataAdapter from './adapter/CorrespondenceDataAdapter';
import { CaseDetailsContext } from '../providers/CaseDetailsProvider';
import { AuthContext } from 'src/state/providers/AuthProvider';
import { CorrespondenceTextEditorConstants } from 'src/constants/ProjectConstants';
import { ListCorrespondenceTypeRequest } from 'src/state/slice/models/CorrespondenceTypes';
import { logger } from 'src/logger';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

const CommentsContainer = () => {
  const [commentList, setCommentList] = useState<Array<IComment>>();
  const { caseId } = useContext(CaseDetailsContext);
  const authDetails = useContext(AuthContext);

  const listCorrespondenceRequest: ListCorrespondenceTypeRequest = {
    userId: authDetails.customerId,
    accountId: authDetails.preferredAccountId,
    caseId: caseId,
  };
  logger.info(
    `Calling listCorrespondence for user ${authDetails.customerId} with Request: `,
    listCorrespondenceRequest,
  );

  const { data, isLoading, error, isError } = useListCorrespondenceQuery(
    listCorrespondenceRequest,
  );

  useEffect(() => {
    logger.info(
      `Fetch listCorrespondence for user ${authDetails.customerId}. Response `,
      { data },
    );
    const correspondenceAdapter = new CorrespondenceDataAdapter(data!);
    const comments = correspondenceAdapter.getUserComments();
    logger.info(
      `List of correspondence parsed into comments successfully for user ${authDetails.customerId}. Comments:`,
      { comments },
    );
    setCommentList(comments);
  }, [data]);

  if (isLoading) {
    return <KatSpinner data-testid="correspondence-loading-spinner" />;
  }

  if (isError) {
    logger.error(
      `Error occured while fetching listCorrespondence for user ${
        authDetails.customerId
      }. Error   ${JSON.stringify(error)}`,
    );

    const { messageBundle } = useContext(TranslationContext);

    return (
      <KatAlert
        description={messageBundle.getMessage(
          CorrespondenceTextEditorConstants.ERROR_LOADING_COMMENTS,
        )}
        variant="danger"
        data-testid="correspondence-comments-alert"
      />
    );
  }

  return (
    <>
      {commentList && commentList.length > 0 && (
        <KatDivider variant="athens"></KatDivider>
      )}
      <Comments commentList={commentList}></Comments>
    </>
  );
};

export default CommentsContainer;
